import { defineStore } from "pinia";
import { ConsultationProcess } from "../types";

export const useConsultationProcessStore = defineStore('consultationProcess', {
    state: () => ({
        consultationProcess: {} as ConsultationProcess
    })
})